import BottomFloatingModal from "components/common/Modal/BottomFloatingModal";
import useModalClickOutside from "utils/useModalClickOutside";
import { TYPO } from "styles/Typo";
import { Check, CheckFill, Forward } from "components/common/Icons";
import Image from "next/image";
import Button from "components/common/buttons/buttons";
import { useRouter } from "next/router";
import {
  formatAccountNo,
  formatDisplayAccountNo,
} from "components/templates/common/Account/util";
import { useKBGlobalState } from "contexts/KBContext";

function SelectAccountModal({
  setModalOpen,
  isModalOpen,
  setAccountChargePage,
}: {
  isModalOpen: boolean;
  setModalOpen: any;
  setAccountChargePage?: any;
}) {
  const modalRef = useModalClickOutside(setModalOpen);
  const { accounts, currentAccount, setCurrentAccount } = useKBGlobalState();
  //현재 url
  const router = useRouter();
  const currentUrl = router.asPath;
  const isMainPage = currentUrl === "/?type=stock";

  return (
    <BottomFloatingModal isOpen={isModalOpen} modalRef={modalRef}>
      <div className="flex flex-col gap-2 w-full py-2">
        {accounts?.map((account: any, index: number) => (
          <div
            key={index}
            className={`flex items-center px-6 py-2 cursor-pointer gap-3`}
            onClick={() => {
              setCurrentAccount(account);
              setModalOpen(false);
            }}
          >
            <Image
              src={"/images/kblogo.png"}
              width={36}
              height={36}
              unoptimized
              alt="kblogo"
            />
            <div className="flex flex-col grow">
              <div className="flex items-center gap-2">
                <span className={`${TYPO.TYPO8_RG} text-gray50`}>
                  {account?.stockName}
                </span>

                {isMainPage && account?.isMainAccount && (
                  <span className={`${TYPO.TYPO8_RG} text-blue40`}>대표</span>
                )}
              </div>

              <div className="flex items-center gap-2">
                {/* <span className={`${TYPO.TYPO5_1_MD} text-gray70 `}>
                  {(account?.balance).toLocaleString()}원
                </span> */}
                <span className={`${TYPO.TYPO5_1_MD} text-gray70 `}>
                  {formatDisplayAccountNo(account?.accountNo)}
                </span>

                {!isMainPage && (
                  <>
                    {/* <div className="h-[10px] w-[1px] bg-gray15"></div> */}
                    <div
                      className={`${TYPO.TYPO7_MD} text-blue40 cursor-pointer`}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        setModalOpen(false);
                        if (setAccountChargePage) {
                          setAccountChargePage(account?.accountNo);
                        }
                      }}
                    >
                      충전
                    </div>
                  </>
                )}
              </div>
            </div>
            {currentAccount?.accountNo === account?.accountNo && (
              <CheckFill fill="blue40" width={24} height={24} />
            )}
          </div>
        ))}
        {isMainPage && (
          <div
            className={`flex items-center px-6 py-2 cursor-pointer gap-3`}
            onClick={() => {
              setModalOpen(false);
              router.push("/kb/mainaccount");
            }}
          >
            <div className="rounded-full w-[40px] h-[40px] bg-gray30 flex items-center justify-center">
              <ChangeAccountIcon />
            </div>
            <span className={`${TYPO.TYPO5_1_MD} text-gray70 grow`}>
              대표 계좌 바꾸기
            </span>
            <Forward fill="gray30" width={16} height={16} />
          </div>
        )}
      </div>
    </BottomFloatingModal>
  );
}

const ChangeAccountIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 12.0508C6 12.3174 6.01667 12.5799 6.05 12.8383C6.08333 13.0966 6.14167 13.3508 6.225 13.6008C6.30833 13.8841 6.3 14.1549 6.2 14.4133C6.1 14.6716 5.925 14.8591 5.675 14.9758C5.40833 15.1091 5.14583 15.1216 4.8875 15.0133C4.62917 14.9049 4.45833 14.7091 4.375 14.4258C4.24167 14.0424 4.14583 13.6508 4.0875 13.2508C4.02917 12.8508 4 12.4508 4 12.0508C4 9.81745 4.775 7.91745 6.325 6.35078C7.875 4.78411 9.76667 4.00078 12 4.00078H12.175L11.275 3.10078C11.0917 2.91745 11 2.68411 11 2.40078C11 2.11745 11.0917 1.88411 11.275 1.70078C11.4583 1.51745 11.6917 1.42578 11.975 1.42578C12.2583 1.42578 12.4917 1.51745 12.675 1.70078L15.275 4.30078C15.475 4.50078 15.575 4.73411 15.575 5.00078C15.575 5.26745 15.475 5.50078 15.275 5.70078L12.675 8.30078C12.4917 8.48411 12.2583 8.57578 11.975 8.57578C11.6917 8.57578 11.4583 8.48411 11.275 8.30078C11.0917 8.11745 11 7.88411 11 7.60078C11 7.31745 11.0917 7.08411 11.275 6.90078L12.175 6.00078H12C10.3333 6.00078 8.91667 6.58828 7.75 7.76328C6.58333 8.93828 6 10.3674 6 12.0508ZM18 11.9508C18 11.6841 17.9833 11.4216 17.95 11.1633C17.9167 10.9049 17.8583 10.6508 17.775 10.4008C17.6917 10.1174 17.7 9.84661 17.8 9.58828C17.9 9.32995 18.075 9.14245 18.325 9.02578C18.5917 8.89245 18.8542 8.87995 19.1125 8.98828C19.3708 9.09661 19.5417 9.29245 19.625 9.57578C19.7583 9.95912 19.8542 10.3508 19.9125 10.7508C19.9708 11.1508 20 11.5508 20 11.9508C20 14.1841 19.225 16.0841 17.675 17.6508C16.125 19.2174 14.2333 20.0008 12 20.0008H11.825L12.725 20.9008C12.9083 21.0841 13 21.3174 13 21.6008C13 21.8841 12.9083 22.1174 12.725 22.3008C12.5417 22.4841 12.3083 22.5758 12.025 22.5758C11.7417 22.5758 11.5083 22.4841 11.325 22.3008L8.725 19.7008C8.525 19.5008 8.425 19.2674 8.425 19.0008C8.425 18.7341 8.525 18.5008 8.725 18.3008L11.325 15.7008C11.5083 15.5174 11.7417 15.4258 12.025 15.4258C12.3083 15.4258 12.5417 15.5174 12.725 15.7008C12.9083 15.8841 13 16.1174 13 16.4008C13 16.6841 12.9083 16.9174 12.725 17.1008L11.825 18.0008H12C13.6667 18.0008 15.0833 17.4133 16.25 16.2383C17.4167 15.0633 18 13.6341 18 11.9508Z"
        fill="white"
      />
    </svg>
  );
};

export default SelectAccountModal;
